
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { Opportunity } from "@/types/database-extensions";
import OpportunityForm from "./OpportunityForm";

interface OpportunityDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  currentOpportunity: Partial<Opportunity>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
  isSubmitting: boolean;
}

const OpportunityDialog: React.FC<OpportunityDialogProps> = ({
  isOpen,
  setIsOpen,
  currentOpportunity,
  handleInputChange,
  handleSubmit,
  isSubmitting,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[550px]">
        <DialogHeader>
          <DialogTitle>
            {currentOpportunity.id ? "Edit Opportunity" : "Create Opportunity"}
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <OpportunityForm
            currentOpportunity={currentOpportunity}
            handleInputChange={handleInputChange}
            isSubmitting={isSubmitting}
          />
          <DialogFooter className="mt-6">
            <Button
              type="button"
              variant="outline"
              onClick={() => setIsOpen(false)}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {currentOpportunity.id ? "Update" : "Create"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default OpportunityDialog;
